import { render } from "./WhatsAppEnableDrawer.vue?vue&type=template&id=6b230ea2&scoped=true"
import script from "./WhatsAppEnableDrawer.vue?vue&type=script&lang=js"
export * from "./WhatsAppEnableDrawer.vue?vue&type=script&lang=js"

import "./WhatsAppEnableDrawer.vue?vue&type=style&index=0&id=6b230ea2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b230ea2"]])

export default __exports__